import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";
import { MainOrganizationCard } from "shared/components/organisms/OrganizationsToChoose/MainOrganizationCard";
import { Organization } from "shared/components/organisms/OrganizationsToChoose/Organization";
import { useAuthContext } from "shared/utils/hooks/useAuthContext";

import { hasRequiredPermissions } from "@Console/utils/checkHasPermission";
import { permissionsAccessAdminConsole } from "@Console/utils/permissionsAreasAdminConsole";

import { OrganizationToChooseContainer } from "./styles";

const OrganizationToChoose = () => {
  const { loggedUser, rolesUser } = useAuthContext();

  const isCoProducer = loggedUser?.has_recipient && !loggedUser?.promoter;
  const hasPermissionAdminConsole = hasRequiredPermissions(
    rolesUser,
    permissionsAccessAdminConsole,
  );

  const orgsList = loggedUser?.subscribed_orgs;

  const shouldShowMainOrganization =
    isCoProducer ||
    hasPermissionAdminConsole ||
    loggedUser?.admin ||
    loggedUser?.superadmin ||
    loggedUser?.id === 1 ||
    loggedUser?.id === 2;

  return (
    <OrganizationToChooseContainer>
      <h1>Qual espaço você gostaria de acessar?</h1>

      <ul>
        {shouldShowMainOrganization && (
          <ComponentErrorBoundary>
            <MainOrganizationCard />
          </ComponentErrorBoundary>
        )}

        {orgsList?.map((org) => (
          <ComponentErrorBoundary key={org?.id}>
            <Organization org={org} />
          </ComponentErrorBoundary>
        ))}
      </ul>
    </OrganizationToChooseContainer>
  );
};

export default OrganizationToChoose;
